/* eslint-disable-next-line no-restricted-imports -- This line is the only place
 * we should be importing from the global Sentry package in this package.
 * Everywhere else we should use the sentryException from this file.
 */
import { sentryFactory, useSentryMultiplex } from '@grantstreet/sentry'
import BaseSentry, { wrapSentryForProject } from '@grantstreet/sentry-multiplex'
import { isProd } from '@grantstreet/psc-environment'

const dsns = {
  // schedpay-vue-prod & -nonprod projects
  prod: 'https://0239ccdd85e14964a8c5f294fa8936e6@o168195.ingest.sentry.io/4504607206998016',
  nonprod: 'https://a96f13e18ba340c0a80feae4f9db119d@o168195.ingest.sentry.io/4504607210143744',
}

export const {
  sentryException: oldSentryException,
  vueErrorHandler,
  chainClient,
} = sentryFactory({ dsns })

// Also export the @grantstreet/sentry-multiplex way of doing things
const Sentry = wrapSentryForProject('schedpay-vue', {
  dsn: () => {
    // If the environment check throws an exception, we will default to logging
    // exceptions in prod, to ensure that we don't miss anything.
    let prod = true
    try {
      prod = isProd()
    }
    catch (error) {
      // If we're being initialized before isProd() works, we must be
      // about to send an event. Add a note to mention that we weren't
      // able to check isProd() in case it's relevant to the problem.
      BaseSentry.addBreadcrumb({
        message: 'Unable to check if prod. Defaulting to using prod Sentry DSN.',
        level: 'warning',
      })
    }

    return prod ? dsns.prod : dsns.nonprod
  },
})
export default Sentry

// This function is just a wrapper to pass the received arguments into the old
// or new sentry exception, based on the feature flag state. This will be a
// shortlived wrapper. This will be removed when the feature flag is removed,
// and the migration is completed.
export const sentryException = (...args) => useSentryMultiplex()
  ? Sentry.captureException(...args)
  : oldSentryException(...args)
